(function() {
  var WISHLIST_KEY = 'tw_wishlist_ids';
  var parser = typeof DOMParser !== 'undefined' ? new DOMParser() : null;

  function getWishlistIds() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlistIds(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  }

  function updateHeaderCount() {
    var ids = getWishlistIds();
    var count = ids ? ids.length : 0;
    document.querySelectorAll('.tw-wishlist-count').forEach(function(el) {
      el.textContent = count;
    });
  }

  window.twWishlist = {
    getIds: getWishlistIds,
    setIds: setWishlistIds,
    updateCount: updateHeaderCount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderCount);
  } else {
    updateHeaderCount();
  }

  if (typeof customElements !== 'undefined' && !customElements.get('button-wishlist')) {
    customElements.define('button-wishlist', class ButtonWishlist extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId || '';
        this.action = this.dataset.action || 'remove';
        this.addTooltip = this.dataset.tooltipAdd || 'Agregar a favoritos';
        this.removeTooltip = this.dataset.tooltipRemove || 'Quitar de favoritos';
        this.redirectTooltip = this.dataset.tooltipRedirect || 'Ver favoritos';
        this.tooltipEl = this.querySelector('.tw-wishlist-tooltip');
        this.init();
      }

      init() {
        this.initStatus();
        this.addEventListener('click', this.onClick.bind(this));
      }

      initStatus() {
        var ids = getWishlistIds();
        if (ids.indexOf(this.productId) !== -1) {
          this.classList.add('tw-wishlist-active');
          if (this.tooltipEl) {
            this.tooltipEl.textContent = this.action === 'remove' ? this.removeTooltip : this.redirectTooltip;
          }
        }
      }

      setActive(allButtons, isAdd) {
        var self = this;
        (allButtons || document.querySelectorAll('button-wishlist[data-product-id="' + self.productId + '"]')).forEach(function(btn) {
          if (isAdd) {
            btn.classList.add('tw-wishlist-active');
            if (btn.tooltipEl) btn.tooltipEl.textContent = self.action === 'remove' ? self.removeTooltip : self.redirectTooltip;
          } else {
            btn.classList.remove('tw-wishlist-active');
            if (btn.tooltipEl) btn.tooltipEl.textContent = self.addTooltip;
          }
        });
      }

      onClick(e) {
        e.preventDefault();
        if (!this.productId) return;
        var ids = getWishlistIds();
        var allBtns = document.querySelectorAll('button-wishlist[data-product-id="' + this.productId + '"]');
        var idx = ids.indexOf(this.productId);
        if (idx === -1) {
          ids.push(this.productId);
          this.setActive(allBtns, true);
        } else {
          if (this.action === 'remove') {
            ids.splice(idx, 1);
            var row = this.closest('.tw-wishlist-item');
            if (row) {
              row.remove();
              var remaining = document.querySelectorAll('.tw-page-wishlist .tw-wishlist-item');
              if (remaining.length === 0) {
                var empty = document.querySelector('.tw-wishlist-empty');
                if (empty) empty.classList.remove('tw-hidden');
              }
            } else {
              this.setActive(allBtns, false);
            }
          } else {
            window.location.href = (window.twRoutes && window.twRoutes.wishlist_url) || '/pages/wishlist';
            return;
          }
        }
        setWishlistIds(ids);
        updateHeaderCount();
      }
    });
  }

  var wishlistPageMain = document.querySelector('.tw-page-wishlist-main');
  if (wishlistPageMain && parser && window.twRoutes && window.twRoutes.search_url) {
    var ids = getWishlistIds();
    var emptyEl = wishlistPageMain.querySelector('.tw-wishlist-empty');
    var sectionEl = document.querySelector('.tw-page-wishlist-section');
    var innerEl = document.querySelector('.tw-page-wishlist-inner');
    var sectionId = sectionEl && sectionEl.dataset.sectionId;
    if (!ids || ids.length === 0) {
      if (innerEl) innerEl.classList.remove('tw-hidden');
      if (emptyEl) emptyEl.classList.remove('tw-hidden');
    } else {
      var query = ids.map(function(id) { return 'id:' + id; }).join('%20OR%20');
      var url = window.twRoutes.search_url + '?section_id=' + sectionId + '&type=product&options[unavailable_products]=last&q=' + query;
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = parser.parseFromString(html, 'text/html');
          var newMain = doc.querySelector('.tw-page-wishlist-main');
          if (newMain && newMain.querySelector('.tw-wishlist-grid')) {
            wishlistPageMain.innerHTML = newMain.innerHTML;
            updateHeaderCount();
            [].slice.call(wishlistPageMain.querySelectorAll('button-wishlist')).forEach(function(btn) {
              btn.tooltipEl = btn.querySelector('.tw-wishlist-tooltip');
              btn.action = btn.dataset.action || 'remove';
              btn.initStatus();
            });
          }
          if (innerEl) innerEl.classList.remove('tw-hidden');
        })
        .catch(function(err) {
          if (emptyEl) emptyEl.classList.remove('tw-hidden');
          if (innerEl) innerEl.classList.remove('tw-hidden');
        });
    }
  }
})();

